import React, {useState} from 'react'
import {Collapse, makeStyles} from "@material-ui/core";
import MembersElementTitle from "./MembersElementTitle";
import MembersElementContent from "./MembersElementContent";

const useStyle = makeStyles(theme => ({
    root: {
        border: `solid 1px ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        padding: `${theme.spacing()}px ${theme.spacing(2)}px`,
        marginBottom: theme.spacing()
    }
}))

function MembersElement(
    {
        index,
        groupId,
        member,
        coordinatorView,
        editable,
        search,
        validationSection
    }) {
    const classes = useStyle();
    const [open, setOpen] = useState(false);


    return (<Collapse in={!search.search || member.name.toLowerCase().indexOf(search.search.toLowerCase()) > -1} unmountOnExit={false}>
        <div className={classes.root}>
            <MembersElementTitle
                groupId={groupId}
                editable={editable}
                index={index}
                member={member}
                open={open}
                onOpen={() => setOpen(!open)}
                coordinatorView={coordinatorView}
                validationSection={validationSection}
            />
            <Collapse in={coordinatorView || open} unmountOnExit>
                <MembersElementContent
                    groupId={groupId}
                    member={member}
                    coordinatorView={coordinatorView}
                    editable={editable}
                    validationSection={validationSection}
                />
            </Collapse>
        </div>
    </Collapse>)
}

MembersElement.propTypes = {}

export default MembersElement;